export default __webpack_public_path__ + "static/replay-ad89e244b4c323561ecca02a276d3157.png";